module.exports = __webpack_public_path__ + "media/images/weather/83_night-5634c43b052b2e455d0427fa8de1b009.png";